module.exports = __webpack_public_path__ + "static/media/Democratic Republic of Congo - CD.512989ca.png";